import type {ReactNode} from 'react'
import {PaginationBar} from '@/components/ui/pagination-bar'
import {DataTable, type Column} from '@/components/data-table'
import {ListCard} from '@/components/section-card'
import {BUSINESSES_PAGE_SIZE, type Business} from '@/hooks/empresa/organizacion/use-businesses'
import type {useTableState} from '@/hooks/common/use-table-state'

type TableState = ReturnType<typeof useTableState>

export function BusinessDirectoryCard({
  table,
  data,
  columns,
  title,
  toolbar,
  onRowClick,
  emptyState,
}: {
  table: TableState
  data: {items: Business[]; total: number} | undefined
  columns: Column<Business>[]
  title?: ReactNode
  toolbar?: ReactNode
  onRowClick: (business: Business) => void
  emptyState: ReactNode
}) {
  return (
    <ListCard
      title={title}
      toolbar={toolbar}
      footer={
        !!data?.total && (
          <PaginationBar
            page={table.page}
            pageSize={BUSINESSES_PAGE_SIZE}
            total={data.total}
            onPageChange={table.setPage}
          />
        )
      }>
      <DataTable
        columns={columns}
        rows={data?.items ?? []}
        rowKey={(b) => b.id}
        sortBy={table.sortBy}
        sortDir={table.sortDir}
        onSort={table.toggleSort}
        onRowClick={onRowClick}
        emptyState={emptyState}
      />
    </ListCard>
  )
}
